import Ail from '~/src/common/assets/ail.svg';
import Button from '~/src/common/components/Button';
import I18n from '~/src/common/services/I18n';

import * as S from './layout';

type Props = {
  onClickRetry: () => unknown;
};

const ErrorLarge = ({ onClickRetry }: Props) => (
  <S.ErrorLargeContainer>
    <Ail />
    <p>{I18n.t('category.error.large.text')}</p>
    <Button onClick={() => void onClickRetry()}>{I18n.t('category.error.large.btn')}</Button>
  </S.ErrorLargeContainer>
);

export default ErrorLarge;
